import i18n from '../setup/lang/i18n';

export default {
    changeLang({
        commit
    }, lang) {
        lang = lang || 'de';
        commit("SET_LANG", lang);
        i18n.locale = lang;
    },

    resetAllData({
        commit
    }) {
        // lang
        let lang = 'de';
        commit("SET_LANG", lang);
        i18n.locale = lang;

        // user
        commit("SET_USER", null);
        commit("SET_USER_LOGIN", null);
        // others
    },

    fetchUser({
        commit
    }, user) {
        if (user) {
            commit("SET_USER", {
                displayName: user.name,
                email: user.email,
                uid: user.uid,
                photoURL: user.photoURL
            });
        } else {
            commit("SET_USER", null);
        }
    },

    updateUserEmail({
        commit
    }, email) {
        commit("SET_USER_EMAIL", email);
    },

    setUserLogin({
        commit
    }, userLogin) {
        commit("SET_USER_LOGIN", userLogin);
    },

    fetchSelectedCompany({
        commit
    }, company) {
        if (company) {
            commit("SET_SELECTED_COMPANY", company);
        } else {
            commit("SET_SELECTED_COMPANY", null);
        }
    },

    showMenu({
        commit
    }, showMenu) {
        commit("SET_SHOW_MENU", showMenu);
    },

    // setIdToken({
    //     commit
    // }, token) {
    //     commit('SET_ID_TOKEN', token);
    // }
}